import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent, ref, computed, useSlots } from 'vue'

const f = 'Flatpickr'

/* eslint-disable */
const r = 'required'


export default /*@__PURE__*/_defineComponent({
  __name: 'ControlDescriptor',
  props: {
  component: {
    type: String,
    default: 'd-control-simple-input',
  },
  name: {
    type: String,
    required: true,
  },
  errors: {
    type: Object,
    default: {},
  },
  isSuccess: Boolean,
  disabled: Boolean,
  inputLabel: String,
  staticLabel: {
    type: Boolean,
    default: false,
  },
  options: {},
  labelBy: String,
  type: {
    type: String,
    default: 'text',
  },
  rules: {
    default: '',
  },
  placeholder: {
    default: '',
  },
  setValue: {},
  updatedValue: {
    type: Boolean,
    default: false,
  },
  value: {},
  id: {},
  searchable: {
    type: Boolean,
    default: false,
  }
},
  emits: ['updateModel', 'update:modelValue', 'input', 'clearMultiselect', 'reset:modelValue'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const flatPicker = ref(null)

const open = () => {
  console.log(flatPicker);
}

const eSlotsResolver = (acc, key) => {
  acc[key] = key
  return acc
}

const getESlots = keys => keys
  .reduce(eSlotsResolver, {})

const props = __props


function containsRequired(value) {
  return typeof value === "string" && value.includes("required") ||
    typeof value === "object" && Object.keys(value).includes("required");
}

const emit = __emit
const inputComponent = resolveComponent(props.component)

const inputValue = ref(null)
const isValid = ref(null)

const getFP = f => {
  const t = { ...f, onChange: () => {} }
  return t
}

const resetValue = val => {
  inputValue.value = null
  emit('updateModel', null)
  emit('reset:modelValue', null)
  emit('update:modelValue', null)
}

const updateValue = val => {
  inputValue.value = val
  emit('updateModel', val)
}
const updateModelValue = val => {
  inputValue.value = val
  emit('update:modelValue', val)
}

const eSlots = computed(() => {
  return getESlots([...Object.keys(useSlots())])
})


const getProps = f => {
  return f ? f.field : {}
}


const __returned__ = { flatPicker, open, f, eSlotsResolver, getESlots, props, containsRequired, emit, inputComponent, inputValue, r, isValid, getFP, resetValue, updateValue, updateModelValue, eSlots, getProps, resolveComponent, ref, computed, useSlots }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})